var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWCoin = function SvgWCoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EF9309",
    d: "m22.148 6.642-5.42 3.509a27 27 0 0 0-4.155 3.311l5.42-3.509a27 27 0 0 1 4.155-3.311"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD500D",
    d: "m17.994 9.951-5.42 3.51c-.871.798-1.666 1.708-2.391 2.658l5.42-3.509c.725-.95 1.52-1.86 2.39-2.659"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF9309",
    d: "m57.248 72.851 5.42-3.509c-4.428 2.868-9.754 4.48-15.582 4.459l-5.421 3.509c5.828.022 11.154-1.591 15.583-4.459"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD500D",
    d: "m43.363 73.565-5.42 3.508c.605.075 1.241.115 1.878.155.602.039 1.238.079 1.838.081l5.42-3.509c-.6-.002-1.235-.043-1.838-.08-.636-.04-1.272-.082-1.878-.156"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF9309",
    d: "m15.6 12.611-5.42 3.51c-4.463 5.55-6.986 12.897-6.763 21.27l5.42-3.509c-.222-8.374 2.3-15.72 6.763-21.27"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD500D",
    d: "m8.845 33.881-5.42 3.51c.017.64.07 1.32.12 1.963.054.68.107 1.359.19 2.004l5.42-3.509a41 41 0 0 1-.19-2.004 38 38 0 0 1-.12-1.964"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF9309",
    d: "m22.198 63.186-5.42 3.51c5.872 5.637 13.298 9.416 21.17 10.376l5.42-3.509c-7.872-.96-15.298-4.74-21.17-10.377"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD500D",
    d: "m19.33 60.196-5.421 3.509c.882 1.051 1.859 2.038 2.866 2.992l5.42-3.51c-1.007-.953-1.984-1.94-2.866-2.991"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF9309",
    d: "m9.152 37.85-5.42 3.509c1.09 8.393 4.798 16.17 10.18 22.344l5.42-3.509c-5.382-6.175-9.089-13.95-10.18-22.344"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_10087_27995)",
    d: "M61.832 19.704c4.293 5.04 7.283 11.311 8.245 18.06l5.625.357c-1.094-8.43-4.801-16.205-10.217-22.383z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_10087_27995)",
    d: "M41.957 8.413c6.33.863 12.264 3.872 17.08 8.375l3.582-4.042c-5.87-5.601-13.295-9.38-21.133-10.34z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_10087_27995)",
    d: "M70.388 41.732c.091 6.694-1.942 12.648-5.487 17.154l4.29 4.576c4.496-5.549 7.047-12.964 6.822-21.374z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_10087_27995)",
    d: "M22.304 14.423c4.159-3.898 9.675-6.216 15.936-6.246l-.47-6.006c-7.8-.031-14.734 2.872-19.781 7.781z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_10087_27995)",
    d: "m66.765 66.083-4.223-4.571c-4.159 3.898-9.674 6.217-15.933 6.282l.47 6.006c7.765.029 14.636-2.843 19.686-7.717"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear_10087_27995)",
    d: "M14.461 34.239c-.125-6.696 1.908-12.65 5.45-17.192l-4.313-4.436c-4.462 5.551-6.986 12.898-6.763 21.271z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear_10087_27995)",
    d: "M18.23 36.434c1.118 14.265 12.874 26.536 26.2 27.38 13.327.844 23.268-10.051 22.15-24.315-1.115-14.229-12.87-26.5-26.197-27.345S17.116 22.206 18.23 36.435m12.037 16.7a31 31 0 0 1-1.739-1.783c-3.223-3.726-5.454-8.385-6.117-13.443a15 15 0 0 1-.128-1.217c-.031-.393-.062-.787-.059-1.178-.127-5.023 1.392-9.445 4.061-12.797.458-.54.916-1.08 1.442-1.58 3.035-2.939 7.195-4.702 11.893-4.689.366-.012.734.012 1.136.037.368.023.737.046 1.108.106 4.71.583 9.187 2.86 12.714 6.213.577.57 1.158 1.176 1.707 1.816 3.258 3.728 5.488 8.387 6.151 13.445.065.396.096.788.126 1.182.034.429.065.822.062 1.213.13 5.06-1.42 9.514-4.09 12.867-.457.54-.948 1.079-1.478 1.543-3.035 2.938-7.164 4.668-11.829 4.657-.366.013-.734-.011-1.102-.035-.402-.025-.77-.048-1.142-.107-4.742-.587-9.185-2.86-12.716-6.25"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear_10087_27995)",
    d: "M42.892 67.558c-6.328-.828-12.264-3.872-17.078-8.339l-3.62 3.968c5.872 5.637 13.298 9.416 21.17 10.377z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear_10087_27995)",
    d: "M22.983 56.265c-4.293-5.04-7.284-11.312-8.211-18.058l-5.625-.357c1.09 8.393 4.798 16.17 10.18 22.344z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_linear_10087_27995)",
    d: "M76.012 42.089c.017-.64-.037-1.319-.09-1.998-.05-.644-.104-1.323-.22-1.97l-5.625-.357c-.962-6.749-3.952-13.021-8.245-18.06l3.654-3.967a32 32 0 0 0-2.866-2.992l-3.582 4.041c-4.817-4.503-10.75-7.511-17.081-8.375l-.47-6.006c-.61-.11-1.245-.15-1.848-.188-.636-.04-1.272-.081-1.87-.047l.471 6.006c-6.26.03-11.776 2.348-15.936 6.246L17.99 9.951c-.87.798-1.665 1.708-2.39 2.658l4.312 4.436c-3.542 4.542-5.575 10.496-5.45 17.191l-5.624-.356c.017.64.07 1.32.12 1.964.054.679.107 1.358.19 2.004l5.626.357c.928 6.746 3.919 13.019 8.21 18.057l-3.657 3.93c.882 1.052 1.86 2.04 2.866 2.992l3.62-3.967c4.815 4.468 10.751 7.512 17.079 8.339l.47 6.006c.606.074 1.242.115 1.879.155.602.038 1.238.079 1.838.08l-.47-6.005c6.258-.066 11.773-2.385 15.933-6.282l4.222 4.571a23.4 23.4 0 0 0 2.427-2.62l-4.29-4.576c3.546-4.507 5.577-10.46 5.487-17.154zM40.383 12.155c13.327.844 25.083 13.115 26.198 27.344 1.117 14.264-8.824 25.16-22.15 24.315-13.327-.845-25.083-13.116-26.2-27.38-1.115-14.23 8.826-25.125 22.152-24.28"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_linear_10087_27995)",
    d: "M62.563 39.244c.034.429.065.822.061 1.213.13 5.06-1.42 9.514-4.088 12.866-.458.54-.949 1.078-1.478 1.542-3.035 2.938-7.164 4.668-11.83 4.657-.365.012-.734-.011-1.102-.034-.402-.026-.77-.049-1.141-.108-4.743-.585-9.186-2.86-12.717-6.249a30 30 0 0 1-1.74-1.782c-3.223-3.726-5.454-8.385-6.116-13.443-.064-.394-.095-.788-.129-1.217-.019-.24-.038-.482-.048-.722a9 9 0 0 1-.01-.456c-.128-5.024 1.392-9.445 4.061-12.797.457-.54.915-1.08 1.442-1.58 3.034-2.938 7.194-4.702 11.893-4.689.365-.012.734.012 1.136.037l.021.001c.361.024.723.047 1.086.105 4.71.583 9.187 2.86 12.714 6.213.577.57 1.159 1.176 1.708 1.816 3.257 3.728 5.49 8.387 6.151 13.445q.049.31.079.62.026.28.047.562"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint11_linear_10087_27995)",
    d: "m38.938 29.388.453.189q-.197.437-.398 1.422a66 66 0 0 0-.373 2.34q-.198 1.332-.397 2.938-.176 1.603-.371 3.259a1152 1152 0 0 1-.351 3.232l-.33 2.908q.657-1.666 1.331-3.408a328 328 0 0 0 1.302-3.48l1.249-3.277q.616-1.588 1.162-2.898a43 43 0 0 1 1.001-2.289q.456-.98.787-1.477.483-.037 1.013-.054a5.5 5.5 0 0 1 1.065.017q.536.058 1.01.22.475.162.803.51-.096.554-.223 1.607-.105 1.026-.233 2.354-.128 1.327-.242 2.851-.114 1.5-.207 2.998-.071 1.47-.126 2.842a68 68 0 0 0-.025 2.363q.57-1.586 1.059-3.636.486-2.074 1.01-4.252.547-2.204 1.213-4.343a23.4 23.4 0 0 1 1.572-3.874q.67-.3 1.392-.53.744-.232 1.482-.264.735-.056 1.441.112.728.142 1.317.594a30 30 0 0 0-1.677 3.111 70 70 0 0 0-1.59 3.652 85 85 0 0 0-1.45 3.939 139 139 0 0 0-1.283 4.025q-.607 2.01-1.105 3.937a98 98 0 0 0-.877 3.596q-.619.073-1.463.213a8 8 0 0 1-1.656.103q-.787-.013-1.39-.34-.579-.302-.691-1.163-.216-1.599-.408-2.876A161 161 0 0 1 43.42 44a72 72 0 0 1-.248-2.614 62 62 0 0 1-.1-3.074 134 134 0 0 1-1.966 6.539 136 136 0 0 0-1.861 6.107 18 18 0 0 0-1.318.003 6 6 0 0 1-1.227-.03 4.7 4.7 0 0 1-1.175-.256q-.547-.207-1.05-.714-.378-1.61-.506-3.862a72 72 0 0 1-.061-4.667q.064-2.439.231-4.764.168-2.323.353-4.102-1.884.444-2.988 1.101-1.107.633-1.69 1.473a5 5 0 0 0-.754 1.897 13.5 13.5 0 0 0-.17 2.274l-.919.072a8 8 0 0 1-.74-.018 3.7 3.7 0 0 1-1.134-.31 2.2 2.2 0 0 1-.818-.706q-.312-.448-.384-1.089-.074-.64.136-1.526a5.65 5.65 0 0 1 1.037-2.118 9.1 9.1 0 0 1 1.825-1.806 11.7 11.7 0 0 1 2.412-1.38 14 14 0 0 1 2.795-.912q1.454-.337 2.93-.376a12.7 12.7 0 0 1 2.908.247"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10087_27995",
    x1: 65,
    x2: -13.334,
    y1: 13.334,
    y2: 115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC9108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10087_27995",
    x1: 65,
    x2: -13.334,
    y1: 13.334,
    y2: 115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC9108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10087_27995",
    x1: 65,
    x2: -13.334,
    y1: 13.334,
    y2: 115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC9108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10087_27995",
    x1: 65,
    x2: -13.334,
    y1: 13.334,
    y2: 115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC9108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10087_27995",
    x1: 65,
    x2: -13.334,
    y1: 13.334,
    y2: 115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC9108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10087_27995",
    x1: 65,
    x2: -13.334,
    y1: 13.334,
    y2: 115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC9108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10087_27995",
    x1: 65,
    x2: -13.334,
    y1: 13.334,
    y2: 115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC9108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10087_27995",
    x1: 65,
    x2: -13.334,
    y1: 13.334,
    y2: 115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC9108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10087_27995",
    x1: 65,
    x2: -13.334,
    y1: 13.334,
    y2: 115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC9108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10087_27995",
    x1: 4.999,
    x2: 88.332,
    y1: 96.666,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1BD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F19100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFAC30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDB400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10087_27995",
    x1: 4.999,
    x2: 88.332,
    y1: 96.666,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1BD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F19100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFAC30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDB400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10087_27995",
    x1: 53.334,
    x2: 24.63,
    y1: 28.334,
    y2: 63.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#FDF270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEB400"
  })))));
};
export default SvgWCoin;